import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { PrimeNG } from 'primeng/config';
import * as CookieConsent from 'vanilla-cookieconsent';

const CAT_NECESSARY = 'necessary';
const CAT_ANALYTICS = 'analytics';
const CAT_ADVERTISEMENT = 'advertisement';
const CAT_FUNCTIONALITY = 'functionality';
const CAT_SECURITY = 'security';

const SERVICE_AD_STORAGE = 'ad_storage';
const SERVICE_AD_USER_DATA = 'ad_user_data';
const SERVICE_AD_PERSONALIZATION = 'ad_personalization';
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage';
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage';
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage';
const SERVICE_SECURITY_STORAGE = 'security_storage';

function updateGtagConsent(): void { }

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, ToastModule, ConfirmDialogModule],
  providers: [
    MessageService,
    ConfirmationService,
  ]
})
export class AppComponent {
  constructor(private _config: PrimeNG,
    
    
  ) {
    this._config.setTranslation({
      startsWith: 'Beginnt mit',
      contains: 'Enthält',
      notContains: 'Enthält nicht',
      endsWith: 'Endet mit',
      equals: 'Gleich',
      notEquals: 'Ungleich',
      noFilter: 'Kein Filter',
      lt: 'Kleiner als',
      today: 'Heute',
      clear: 'Löschen',
      matchAll: 'Alle übereinstimmen',
      matchAny: 'Beliebige übereinstimmen',
      addRule: 'Regel hinzufügen',
      removeRule: 'Regel entfernen',
      accept: 'Akzeptieren',
      reject: 'Ablehnen',
      choose: 'Wählen',
      cancel: 'Abbrechen',
      upload: 'Hochladen',
      apply: 'Anwenden',
      monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ],
      dayNames: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag',
      ],
      dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    });


    CookieConsent.run({
      onFirstConsent: () => {
        updateGtagConsent();
      },
      onConsent: () => {
        updateGtagConsent();
      },
      onChange: () => {
        updateGtagConsent();
      },

      categories: {
        [CAT_NECESSARY]: {
          enabled: true, // this category is enabled by default
          readOnly: true, // this category cannot be disabled
        },
        [CAT_ANALYTICS]: {
          autoClear: {
            cookies: [
              {
                name: /^_ga/, // regex: match all cookies starting with '_ga'
              },
              {
                name: '_gid', // string: exact cookie name
              },
            ],
          },
          // See: https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
          services: {
            [SERVICE_ANALYTICS_STORAGE]: {
              label:
                'Ermöglicht die Speicherung (z. B. Cookies) im Zusammenhang mit Analysen, z. B. Besuchsdauer.',
            },
          },
        },
        [CAT_ADVERTISEMENT]: {
          services: {
            [SERVICE_AD_STORAGE]: {
              label:
                'Ermöglicht die Speicherung (z. B. Cookies) im Zusammenhang mit Werbung.',
            },
            [SERVICE_AD_USER_DATA]: {
              label:
                'Erteilt die Zustimmung zur Übermittlung von Benutzerdaten im Zusammenhang mit Werbung an Google.',
            },
            [SERVICE_AD_PERSONALIZATION]: {
              label: 'Erteilt die Zustimmung für personalisierte Werbung.',
            },
          },
        },
        [CAT_FUNCTIONALITY]: {
          services: {
            [SERVICE_FUNCTIONALITY_STORAGE]: {
              label:
                'Ermöglicht die Speicherung, die die Funktionalität der Website oder App unterstützt, z. B. Spracheinstellungen.',
            },
            [SERVICE_PERSONALIZATION_STORAGE]: {
              label:
                'Ermöglicht die Speicherung im Zusammenhang mit Personalisierung, z. B. Videoempfehlungen.',
            },
          },
        },
        [CAT_SECURITY]: {
          services: {
            [SERVICE_SECURITY_STORAGE]: {
              label:
                'Ermöglicht die Speicherung im Zusammenhang mit Sicherheit, wie z. B. Authentifizierungsfunktionen, Betrugsprävention und anderem Benutzerschutz.',
            },
          },
        },
      },
      language: {
        default: 'de',
        translations: {
          de: {
            consentModal: {
              title: 'Ich liebe Cookies 🍪',
              description:
                'Ich habe ein paar Cookies für dich gebacken—vertrau mir, sie sind essenziell, um diese Website zu genießen. Ohne sie funktioniert es einfach nicht. Um Informationen zu sammeln und deine Erfahrung zu verbessern, möchte ich auch einige Cookies von Drittanbietern verwenden. Wäre das in Ordnung?',
              acceptAllBtn: 'Ja, das ist okay',
              acceptNecessaryBtn: 'Nein, danke',
              showPreferencesBtn: 'Individuelle Einstellungen verwalten',
            },
            preferencesModal: {
              title: 'Cookies verwalten',
              acceptAllBtn: 'Alle akzeptieren',
              acceptNecessaryBtn: 'Alle ablehnen',
              savePreferencesBtn: 'Aktuelle Auswahl akzeptieren',
              closeIconLabel: 'Modal schließen',
              sections: [
                {
                  title: 'Simon liebt Cookies!',
                  description:
                    'Ich verwende Cookies, um die Website zu personalisieren. Um dir die beste Erfahrung zu bieten, merke ich mir deine Präferenzen und wiederhole Besuche. Durch Klicken auf „Akzeptieren“ stimmst du der Verwendung aller Cookies zu.',
                },
                {
                  title: 'Notwendige Cookies',
                  description:
                    'Diese Cookies sind notwendig, damit die Website funktioniert, und können in unseren Systemen nicht deaktiviert werden. Sie werden normalerweise nur als Reaktion auf von dir getätigte Aktionen gesetzt, die einer Anfrage nach Diensten entsprechen, wie das Festlegen deiner Datenschutzeinstellungen, das Einloggen oder das Ausfüllen von Formularen.',

                  //this field will generate a toggle linked to the 'necessary' category
                  linkedCategory: CAT_NECESSARY,
                },
                {
                  title: 'Performance and Analytics',
                  description:
                    'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                  linkedCategory: CAT_ANALYTICS,
                  cookieTable: {
                    headers: {
                      name: 'Name',
                      domain: 'Service',
                      description: 'Description',
                      expiration: 'Expiration',
                    },
                    body: [
                      {
                        name: '_ga',
                        domain: 'Google Analytics',
                        description:
                          'Cookie set by <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
                        expiration: 'Expires after 12 days',
                      },
                      {
                        name: '_gid',
                        domain: 'Google Analytics',
                        description:
                          'Cookie set by <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
                        expiration: 'Session',
                      },
                    ],
                  },
                },
                {
                  title: 'Advertising',
                  description:
                    'Google uses cookies for advertising, including serving and rendering ads, personalizing ads (depending on your ad settings at <a href="https://g.co/adsettings">g.co/adsettings</a>), limiting the number of times an ad is shown to a user, muting ads you have chosen to stop seeing, and measuring the effectiveness of ads.',
                  linkedCategory: CAT_ADVERTISEMENT,
                },
                {
                  title: 'Functionality',
                  description:
                    'Cookies used for functionality allow users to interact with a service or site to access features that are fundamental to that service. Things considered fundamental to the service include preferences like the user’s choice of language, product optimizations that help maintain and improve a service, and maintaining information relating to a user’s session, such as the content of a shopping cart.',
                  linkedCategory: CAT_FUNCTIONALITY,
                },
                {
                  title: 'Security',
                  description:
                    'Cookies used for security authenticate users, prevent fraud, and protect users as they interact with a service.',
                  linkedCategory: CAT_SECURITY,
                },
                {
                  title: 'More information',
                  description:
                    'For any queries in relation to my policy on cookies and your choices, please <a href="#contact">contact me</a>',
                },
              ],
            },
          },
        },
      },
    });
  }
}
